import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import PaymentList from './components/PaymentList.vue'
import PaymentForm from './components/PaymentForm.vue'
import ContragentList from './components/ContragentList.vue'
import ContragentForm from './components/ContragentForm.vue'
import LiteratureList from './components/LiteratureList.vue'
import LiteratureForm from './components/LiteratureForm.vue'
import EventList from './components/EventList.vue'
import EventForm from './components/EventForm.vue'
import Labels from './components/Labels.vue'
import UserList from './components/UserList.vue'
import UserForm from './components/UserForm.vue'
// import Reports from './components/Reports.vue'
const Reports = resolve => require(['./components/Reports.vue'], resolve)

export default [
  {path: '/login', component: Login, meta: {auth: false}},
  {path: '/', component: Dashboard, redirect: '/payments', meta: {auth: true}},
  {path: '/payments', component: PaymentList, meta: {auth: ['admin', 'payments']}},
  {path: '/payments/:id', component: PaymentForm, meta: {auth: ['admin', 'payments']}},
  {path: '/contragents', component: ContragentList, meta: {auth: ['admin', 'contragents']}},
  {path: '/contragents/:id', component: ContragentForm, meta: {auth: ['admin', 'contragents']}},
  {path: '/literature', component: LiteratureList, meta: {auth: ['admin', 'literature']}},
  {path: '/literature/:id', component: LiteratureForm, meta: {auth: ['admin', 'literature']}},
  {path: '/events', component: EventList, meta: {auth: ['admin', 'events']}},
  {path: '/events/:id', component: EventForm, meta: {auth: ['admin', 'events']}},
  {path: '/labels', component: Labels, meta: {auth: ['admin', 'labels']}},
  {path: '/reports', component: Reports, meta: {auth: ['admin', 'reports']}},
  {path: '/users', component: UserList, meta: {auth: ['admin', 'users']}},
  {path: '/users/:id', component: UserForm, meta: {auth: true}},
  {path: '*', redirect: {path: '/'}}
]
